import styled from 'styled-components'
import { breakpoints } from '../../utils/styles/global-styles'

export const MobileToggle = styled.button`
  display: none;
  width: 100%;
  max-width: 400px;
  margin: auto;
  padding: 12px 16px;
  background: ${(props) => props.theme.whiteLight};
  border: 1px solid ${(props) => props.theme.grayLight};
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => props.theme.grayDark};
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.grayLight};
  }

  @media (max-width: ${breakpoints.xl}px) {
    display: flex;
  }
`

export const MobileNavParent = styled.div`
  @media (max-width: ${breakpoints.xl}px) {
    margin-bottom: 32px;
  }
`

export const MobileNavContainer = styled.div`
  @media (max-width: ${breakpoints.xl}px) {
    max-height: ${(props) => (props.isExpanded ? '500px' : '0')};
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
  }
`

// NB: There is a global style applied to all divs with padding-right right now.
// Rather than trying to fix it here, I'm just overriding it -scotty
export const MobileNavContent = styled.div`
  @media (max-width: ${breakpoints.xl}px) {
    padding: 0 16px 16px;
    padding-right: 16px !important;
    background: ${(props) => props.theme.whiteLight};
    border: 1px solid ${(props) => (props.isExpanded ? props.theme.grayLight : 'transparent')};
    border-top: none;
    border-radius: 0 0 4px 4px;
  }
`
